(function () {
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = products.length;

    document.querySelectorAll('.filters__item').forEach(item => {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        document.querySelectorAll('.filters__item').forEach(element => {
          element.classList.remove('filters__item_active');
        })
        item.classList.add('filters__item_active');

        let i = 0;
        products.forEach(element => {
          let productType = element.dataset.type;
          if ((productType == typeTarget || typeTarget == "all") && i < limit) {
            element.classList.add('show');
            i++;
          }
          else {
            element.classList.remove('show');
          }
        });
      })
    })
  }

  productsFilters();

  document.addEventListener('shopify:section:load', function () {
		productsFilters();
	});
})();

/* ==========================================================================
   Popular Products Tabs — améliorations mobile (<= 989px)
   Swipe des images produit + animation tap du bouton « Voir plus ».
   Le desktop (>= 990px) n'est pas touché.
   ========================================================================== */
(function () {
  if (window.__pptMobile) return;
  window.__pptMobile = true;

  var MQ = window.matchMedia('(max-width: 989px)');
  var SECTION = '.popular-products-section';
  var CARD = SECTION + ' li.collection-product-card';
  var MAX_IMAGES = 6;
  var cache = {};
  var io = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fileKey(src) {
    return (src || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/, '');
  }

  function sized(src, w) {
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  /* Swipe des images produit */
  function build(card) {
    if (card.dataset.pptSwipe) return;
    var media = card.querySelector('.card__inner .media');
    var img = media && (media.querySelector('img.media--first') || media.querySelector('img'));
    var handle = handleOf(card);
    if (!media || !img || !handle) return;
    card.dataset.pptSwipe = 'pending';

    fetchProduct(handle).then(function (p) {
      if (!p || !MQ.matches || !card.isConnected) { card.dataset.pptSwipe = ''; return; }

      var list = (p.media && p.media.length)
        ? p.media.filter(function (m) { return m.media_type === 'image' && m.src; })
            .map(function (m) { return { src: m.src, alt: m.alt }; })
        : (p.images || []).map(function (s) { return { src: s, alt: '' }; });

      var firstKey = fileKey(img.currentSrc || img.src);
      var extras = list.filter(function (m) { return fileKey(m.src) !== firstKey; }).slice(0, MAX_IMAGES - 1);
      if (!extras.length) { card.dataset.pptSwipe = 'single'; return; }

      var fit = getComputedStyle(img).objectFit || 'contain';
      var track = document.createElement('div');
      track.className = 'ppt-swipe';
      track.setAttribute('aria-label', (p.title || '') + ' — images');

      var marker = document.createComment('ppt-img');
      img.parentNode.insertBefore(marker, img);
      var s0 = document.createElement('div');
      s0.className = 'ppt-swipe__slide';
      s0.appendChild(img);
      track.appendChild(s0);

      extras.forEach(function (m, i) {
        var s = document.createElement('div');
        s.className = 'ppt-swipe__slide';
        var im = document.createElement('img');
        im.alt = m.alt || p.title || '';
        im.decoding = 'async';
        if (i > 0) im.loading = 'lazy';
        im.sizes = img.getAttribute('sizes') || '(max-width: 749px) 50vw, 33vw';
        im.srcset = [360, 540, 720, 900].map(function (w) { return sized(m.src, w) + ' ' + w + 'w'; }).join(', ');
        im.src = sized(m.src, 540);
        im.style.objectFit = fit;
        s.appendChild(im);
        track.appendChild(s);
      });

      var dots = document.createElement('div');
      dots.className = 'ppt-dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < extras.length + 1; d++) {
        var dot = document.createElement('i');
        if (d === 0) dot.className = 'is-active';
        dots.appendChild(dot);
      }

      media.appendChild(track);
      media.appendChild(dots);

      var current = 0;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (idx !== current && dots.children[idx]) {
            dots.children[current].classList.remove('is-active');
            dots.children[idx].classList.add('is-active');
            current = idx;
          }
        });
      }, { passive: true });

      // Tap simple (sans swipe) sur l'image : ouvre la fiche produit comme avant
      track.addEventListener('click', function () {
        var link = card.querySelector('.link--overlay') || card.querySelector('.card__title a');
        if (link) link.click();
      });

      // Changement de couleur : retour sur l'image principale mise à jour
      card.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') track.scrollTo({ left: 0, behavior: 'auto' });
      });

      card._pptTeardown = function () {
        if (marker.parentNode) marker.parentNode.insertBefore(img, marker);
        marker.remove();
        track.remove();
        dots.remove();
        card.dataset.pptSwipe = '';
        card._pptTeardown = null;
      };
      card.dataset.pptSwipe = 'ready';
    });
  }

  function observe() {
    if (!MQ.matches) return;
    var cards = document.querySelectorAll(CARD);
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(build); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.unobserve(en.target); build(en.target); }
        });
      }, { rootMargin: '300px 0px' });
    }
    cards.forEach(function (c) { if (!c.dataset.pptSwipe) io.observe(c); });
  }

  function teardownAll() {
    if (io) { io.disconnect(); io = null; }
    document.querySelectorAll(CARD).forEach(function (c) {
      if (c._pptTeardown) c._pptTeardown();
      else if (c.dataset.pptSwipe !== 'pending') c.dataset.pptSwipe = '';
    });
  }

  /* Voir plus : l'animation hover desktop devient une animation au tap */
  var PRESS_MS = 260;
  function moreBtn(e) {
    return e.target && e.target.closest ? e.target.closest(SECTION + ' .button--simple-move') : null;
  }
  document.addEventListener('pointerdown', function (e) {
    var b = moreBtn(e);
    if (!b || !MQ.matches) return;
    b.classList.add('is-pressed');
    b._pptPressedAt = performance.now();
  }, { passive: true });
  document.addEventListener('pointercancel', function (e) {
    var b = moreBtn(e);
    if (b) b.classList.remove('is-pressed');
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var b = moreBtn(e);
    if (!b || !MQ.matches || !b.href) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || b.target === '_blank') return;
    e.preventDefault();
    b.classList.add('is-pressed');
    var elapsed = performance.now() - (b._pptPressedAt || performance.now());
    setTimeout(function () { window.location.href = b.href; }, Math.max(0, PRESS_MS - elapsed));
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll(SECTION + ' .button--simple-move.is-pressed').forEach(function (b) {
      b.classList.remove('is-pressed');
    });
  });

  function onMQ() { if (MQ.matches) observe(); else teardownAll(); }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else MQ.addListener(onMQ);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', function () { setTimeout(observe, 50); });
})();

/* ==========================================================================
   Popular Products Tabs — swipe à la souris / trackpad (<= 989px)
   Utile dans l'aperçu mobile de l'éditeur Shopify et les petites fenêtres.
   Sur téléphone, le swipe tactile natif reste utilisé.
   ========================================================================== */
(function () {
  if (window.__pptMouseDrag) return;
  window.__pptMouseDrag = true;
  var drag = null;
  function trackOf(e) {
    return e.target && e.target.closest ? e.target.closest('.popular-products-section .ppt-swipe') : null;
  }
  document.addEventListener('dragstart', function (e) {
    if (trackOf(e)) e.preventDefault();
  });
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = trackOf(e);
    if (!track) return;
    drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.track.style.scrollSnapType = 'none';
      drag.track.style.scrollBehavior = 'auto';
    }
    if (drag.moved) {
      e.preventDefault();
      drag.track.scrollLeft = drag.left - dx;
    }
  });
  function end(e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    var t = d.track;
    var w = Math.max(t.clientWidth, 1);
    var dx = (e.clientX || d.x) - d.x;
    var start = Math.round(d.left / w);
    var idx = Math.abs(dx) > w * 0.15 ? start + (dx < 0 ? 1 : -1) : start;
    idx = Math.max(0, Math.min(idx, t.children.length - 1));
    t.style.scrollBehavior = '';
    t.scrollTo({ left: idx * w, behavior: 'smooth' });
    setTimeout(function () { t.style.scrollSnapType = ''; }, 450);
    // Le clic qui suit un glisser ne doit pas ouvrir la fiche produit
    var block = function (ev) { ev.stopImmediatePropagation(); ev.preventDefault(); };
    t.addEventListener('click', block, true);
    setTimeout(function () { t.removeEventListener('click', block, true); }, 60);
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
})();
